import { ProductRow as ProductRowUI } from '@components/Product/ProductRow';
import { getProductCardTabletClasses } from '@components/Product/productCardTabletStyles';
import { HeadlessProductCardWrapper } from '@components/Search/HeadlessProductCardWrapper';
import { useResults } from '@components/Search/hooks/useResults';
import { useProductLists } from '@contexts/ProductListsContext';
import { useProductTags } from '@contexts/ProductTagsContext';
import { CoveoListingContext } from '@contexts/coveo/CoveoListingContext';
import { useContext, useEffect, useRef } from 'react';

export const DynamicProductListingCards = ({
  gridCols,
}: {
  gridCols: number;
}) => {
  const { searchEngine } = useContext(CoveoListingContext);
  const { results: resultState } = useResults(searchEngine);
  const productTags = useProductTags();
  const mappedProductTags = productTags ?? [];
  const { fetchBatchProductMembership } = useProductLists();
  const prevKeyRef = useRef('');

  useEffect(() => {
    if (!resultState?.results || resultState.results.length === 0) return;

    const productIds = resultState.results
      .map((r) => {
        const rawId = r.raw.ec_product_id;
        return rawId ? JSON.parse(rawId as string).toString() : '';
      })
      .filter(Boolean);

    const key = productIds.join(',');
    if (key && key !== prevKeyRef.current) {
      prevKeyRef.current = key;
      fetchBatchProductMembership(productIds);
    }
  }, [resultState?.results, fetchBatchProductMembership]);

  if (!resultState?.results || resultState?.results.length === 0) {
    return null;
  }

  return (
    <ProductRowUI gridCols={gridCols}>
      {resultState?.results.map((result, index) => (
        <HeadlessProductCardWrapper
          key={result.raw.ec_product_id as string}
          context={CoveoListingContext}
          result={result}
          allProductTags={mappedProductTags}
          className={getProductCardTabletClasses(
            index,
            resultState.results.length
          )}
        />
      ))}
    </ProductRowUI>
  );
};
